import { Component } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CustomizedTextField from "../../Input/CustomizedTextField";
import { connect } from "react-redux";
import Button from "@mui/material/Button/Button";

class DetailsTab extends Component {
    render() {
        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin without-side-padding">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className="row div-center">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="code"
                                label="Code"
                                className="full_size light-disabled"
                                value={this.props.componentPark.code}
                                margin="normal"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="ref"
                                label={this.props.extranet ? "Votre référence" : "Ref client"}
                                className="full_size light-disabled"
                                value={this.props.componentPark.customer_ref}
                                margin="normal"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="name"
                                label="Nom"
                                className="full_size light-disabled"
                                value={this.props.componentPark.name}
                                margin="normal"
                                multiline
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <Button
                                margin="normal"
                                className={
                                    "disabled " +
                                    (this.props.componentPark.has_contract ? "green-button" : "red-button")
                                }
                            >
                                {this.props.componentPark.has_contract ? "Sous contrat" : "Hors contrat"}
                            </Button>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="description"
                                label="Description"
                                className="full_size light-disabled"
                                value={this.props.componentPark.complete_name}
                                margin="normal"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="Parc"
                                label="Parc"
                                className="full_size light-disabled"
                                value={this.props.componentPark.park_id.name}
                                margin="normal"
                            />
                        </div>
                        {!this.props.extranet ? (
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                <CustomizedTextField
                                    id="customer"
                                    label="Client (RS, Ville)"
                                    className="full_size light-disabled"
                                    value={
                                        this.props.componentPark.partner_id.name +
                                        "(" +
                                        this.props.componentPark.partner_id.customer_code +
                                        ") \r\n" +
                                        this.props.componentPark.partner_id.address
                                    }
                                    margin="normal"
                                    multiline
                                />
                            </div>
                        ) : null}
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="date"
                                label="Date MES"
                                className="full_size light-disabled"
                                value={
                                    this.props.componentPark.commissioning_date
                                        ? this.props.componentPark.commissioning_date
                                        : ""
                                }
                                margin="normal"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="comment"
                                label="Commentaire"
                                className="full_size light-disabled"
                                value={this.props.componentPark.comment}
                                margin="normal"
                                multiline
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="attributes"
                                label="Attributs"
                                className="full_size light-disabled"
                                value={this.props.componentPark.attributes_description}
                                margin="normal"
                                multiline
                            />
                        </div>
                    </div>
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        componentPark: state.componentsPark.currentComponent,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTab);
